import { render, staticRenderFns } from "./AddBulkQuestions.vue?vue&type=template&id=bf4832f2"
import script from "./AddBulkQuestions.vue?vue&type=script&lang=js"
export * from "./AddBulkQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports